<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="d-flex flex-column">
    <form
      id="complaintTheme"
      :action="actionUrl"
      method="POST"
    >
      <input
        type="hidden"
        name="_csrf"
        :value="csrfToken"
      />
      <div>
        <h5 class="font-weight-bold text-break js-complain-object">
          {{ $t('message.reportOn', { obj: recipientName }) }}
        </h5>
        <div class="form-group mt-3 mb-0">
          <label class="w-100">
            {{ $t('message.reportReason') }}
            <div
              v-if="this.reportType === 'project'"
              class="form-group"
            >
              <select
                id="complaint-title"
                v-model="form.title"
                class="form-control"
                name="title"
                required
              >
                <option>{{ $t('message.reportReasons.projectContent') }}</option>
                <option>{{ $t('message.reportReasons.legalViolation') }}</option>
                <option>{{ $t('message.reportReasons.spam') }}</option>
                <option>{{ $t('message.reportReasons.maliciousSoftware') }}</option>
                <option>{{ $t('message.reportReasons.other') }}</option>
              </select>
            </div>
            <div
              v-else
              class="form-group"
            >
              <select
                id="complaint-title"
                v-model="form.title"
                class="form-control"
                name="title"
                required
              >
                <option>{{ $t('message.reportReasons.userProjectContent') }}</option>
                <option>{{ $t('message.reportReasons.legalViolation') }}</option>
                <option>{{ $t('message.reportReasons.fraud') }}</option>
                <option>{{ $t('message.reportReasons.spam') }}</option>
                <option>{{ $t('message.reportReasons.other') }}</option>
              </select>
            </div>
            <small
              v-if="formValidationErrors?.title"
              class="text-danger"
            >
              {{ formValidationErrors?.title }}
            </small>
          </label>
        </div>
        <div class="form-group">
          <label class="w-100">
            {{ $tc('message.description') }}
            <textarea
              id="complaint-message"
              v-model="form.message"
              class="form-control"
              name="message"
              rows="3"
              required
            />
            <small
              v-if="formValidationErrors?.message"
              class="text-danger"
            >
              {{ formValidationErrors?.message }}
            </small>
          </label>
        </div>
      </div>
      <div class="modal-footer px-0 pb-0">
        <button
          :type="isAsync ? 'button' : 'submit'"
          class="btn btn-sm btn-primary"
          @click="onReportClick"
        >
          {{ $t('message.send') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';

export default {
  name: 'ReportForm',
  props: {
    csrfToken: {
      type: String,
      default: null
    },
    reportType: {
      type: String,
      default: null,
      required: true
    },
    recipientName: {
      type: String,
      default: null
    },
    actionUrl: {
      type: String,
      default: null
    },
    isAsync: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        title: null,
        message: null
      }
    };
  },
  computed: {
    formValidationErrors() {
      return this.$store.getters.getFormErrors(FORM_NAME_ENUMS.REPORT_PROJECT);
    }
  },
  watch: {
    recipientName() {
      this.resetReportForm();
      this.form.title =
        this.reportType === 'project'
          ? this.$t('message.reportReasons.projectContent')
          : this.$t('message.reportReasons.userProjectContent');
    }
  },
  methods: {
    onReportClick() {
      this.$emit('submit', this.form);
    },
    resetReportForm() {
      this.form = {
        title: null,
        message: null
      };
    }
  }
};
</script>
